var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstClass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 80",
    fill: "none",
    stroke: "#002333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 8.70001H15.9C17.2 8.70001 18.3 9.80001 18.3 11.1V64.6L15.4 73.1C15.2 73.6 14.4 73.6 14.2 73.1L11.3 64.6V11.1C11.3 9.80001 12.3 8.70001 13.7 8.70001Z",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 14.9H11.3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 21.4H11.3",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3 64.6C18.3 64.6 17 62.5 14.8 62.5C12.6 62.5 11.3 64.6 11.3 64.6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2 49.1H88.6C90.4 49.1 91.9 50.6 91.9 52.4V71.2C91.9 73 90.4 74.5 88.6 74.5H52.9C51.1 74.5 49.6 73 49.6 71.2V52.3C49.6 50.5 51.1 49 52.9 49H63.9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7999 71.1999C76.2182 71.1999 79.7999 67.6182 79.7999 63.2C79.7999 58.7817 76.2182 55.2 71.7999 55.2C67.3817 55.2 63.7999 58.7817 63.7999 63.2C63.7999 67.6182 67.3817 71.1999 71.7999 71.1999Z",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3 52.8H65.2C64.2 52.8 63.4 51.9 63.7 50.9L64.9 45.8C65.1 45.1 65.7 44.6 66.4 44.6H77.1C77.8 44.6 78.4 45.1 78.6 45.8L79.8 50.9C80.1 51.8 79.4 52.8 78.3 52.8Z",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8 68.1C74.5062 68.1 76.7 65.9062 76.7 63.2C76.7 60.4938 74.5062 58.3 71.8 58.3C69.0938 58.3 66.9 60.4938 66.9 63.2C66.9 65.9062 69.0938 68.1 71.8 68.1Z",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8 49.1C56.8 49.1 58.2 51.6 58.2 55.8C58.2 60 56 61.8 56 65C56 68.1 58.1 69.4 58.1 74.4",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9001 49.1C54.9001 49.1 54.9001 27.6 54.9001 18C41.8001 10.7 29.7001 15.3 25.7001 17.3C24.8001 17.7 24.3 18.6 24.3 19.5V62.6C24.3 64.3 26.0001 65.5 27.7001 64.9C31.1001 63.6 41.5001 61.7 49.7001 64",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9 49.1C54.9 49.1 54.9 27.6 54.9 18C68 10.7 80.1 15.3 84.1 17.3C85 17.7 85.5 18.6 85.5 19.5V49.5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 23.2C29.8 23.2 40.3 19.1 49.1 23.2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 29.4C29.8 29.4 40.3 25.3 49.1 29.4",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 35.6C29.8 35.6 40.3 31.5 49.1 35.6",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstClass);
export default __webpack_public_path__ + "static/media/first-class.fe2bf6a9709510b5de7330600e1812af.svg";
export { ForwardRef as ReactComponent };